module.exports = __webpack_public_path__ + "images/mobile/home/customer-logowall-2d5fdbdb9c18b58e21abbeb9e92159fc.png";